import { render, staticRenderFns } from "./LandingpageFooter.vue?vue&type=template&id=45586b5a"
import script from "./LandingpageFooter.vue?vue&type=script&lang=js"
export * from "./LandingpageFooter.vue?vue&type=script&lang=js"
import style0 from "./LandingpageFooter.vue?vue&type=style&index=0&id=45586b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports